//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.20.0.0 (NJsonSchema v11.0.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming
import * as Types from '../api-client.types';
import { useQuery, useMutation } from '@tanstack/react-query';
import type { UseQueryResult, QueryFunctionContext, UseQueryOptions, QueryClient, QueryKey, MutationKey, UseMutationOptions, UseMutationResult, QueryMeta, MutationMeta } from '@tanstack/react-query';
import { trimArrayEnd, isParameterObject, getBaseUrl, addMetaToOptions } from './helpers';
import type { QueryMetaContextValue } from 'react-query-swagger';
import { QueryMetaContext } from 'react-query-swagger';
import { useContext } from 'react';
import * as Client from './MeasurementImportSettingsClient'
export { Client };
import type { AxiosRequestConfig } from 'axios';

export type GetMeasurementImportSettingsQueryParameters = {
  deviceModel?: Types.DeviceModel | undefined ;
}

export type PatchMeasurementImportSettingsQueryParameters = {
  deviceModel?: Types.DeviceModel | undefined ;
}

export function getUrl(deviceModel?: Types.DeviceModel | undefined): string {
  let url_ = getBaseUrl() + "/api/measurements/import-settings?";
if (deviceModel === null)
    throw new Error("The parameter 'deviceModel' cannot be null.");
else if (deviceModel !== undefined)
    url_ += "deviceModel=" + encodeURIComponent("" + deviceModel) + "&";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

let getDefaultOptions: Omit<UseQueryOptions<Types.MeasurementImportSettingsDto, unknown, Types.MeasurementImportSettingsDto>, 'queryKey' | 'queryFn'> & Partial<Pick<UseQueryOptions<Types.MeasurementImportSettingsDto, unknown, Types.MeasurementImportSettingsDto>, 'queryFn'>> = {
};
export function getGetDefaultOptions() {
  return getDefaultOptions;
};
export function setGetDefaultOptions(options: typeof getDefaultOptions) {
  getDefaultOptions = options;
}

export function getQueryKey(deviceModel?: Types.DeviceModel | undefined): QueryKey;
export function getQueryKey(...params: any[]): QueryKey {
  if (params.length === 1 && isParameterObject(params[0])) {
    const { deviceModel,  } = params[0] as GetMeasurementImportSettingsQueryParameters;

    return trimArrayEnd([
        'MeasurementImportSettingsClient',
        'get',
        deviceModel as any,
      ]);
  } else {
    return trimArrayEnd([
        'MeasurementImportSettingsClient',
        'get',
        ...params
      ]);
  }
}
export function __get(context: QueryFunctionContext, axiosConfig?: AxiosRequestConfig | undefined) {
  return Client.get(
      context.queryKey[2] as Types.DeviceModel | undefined,axiosConfig    );
}

export function useGetQuery<TSelectData = Types.MeasurementImportSettingsDto, TError = unknown>(dto: GetMeasurementImportSettingsQueryParameters, options?: Omit<UseQueryOptions<Types.MeasurementImportSettingsDto, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
/**
 * Gets Measurement import settings for current tenant.
 * @param deviceModel (optional) 
 */
export function useGetQuery<TSelectData = Types.MeasurementImportSettingsDto, TError = unknown>(deviceModel?: Types.DeviceModel | undefined, options?: Omit<UseQueryOptions<Types.MeasurementImportSettingsDto, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
export function useGetQuery<TSelectData = Types.MeasurementImportSettingsDto, TError = unknown>(...params: any []): UseQueryResult<TSelectData, TError> {
  let options: UseQueryOptions<Types.MeasurementImportSettingsDto, TError, TSelectData> | undefined = undefined;
  let axiosConfig: AxiosRequestConfig |undefined = undefined;
  let deviceModel: any = undefined;
  
  if (params.length > 0) {
    if (isParameterObject(params[0])) {
      ({ deviceModel,  } = params[0] as GetMeasurementImportSettingsQueryParameters);
      options = params[1];
      axiosConfig = params[2];
    } else {
      [deviceModel, options, axiosConfig] = params;
    }
  }

  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);

  return useQuery<Types.MeasurementImportSettingsDto, TError, TSelectData>({
    queryFn: axiosConfig ? (context) => __get(context, axiosConfig) : __get,
    queryKey: getQueryKey(deviceModel),
    ...getDefaultOptions as unknown as Omit<UseQueryOptions<Types.MeasurementImportSettingsDto, TError, TSelectData>, 'queryKey'>,
    ...options,
  });
}
/**
 * Gets Measurement import settings for current tenant.
 * @param deviceModel (optional) 
 */
export function setGetData(queryClient: QueryClient, updater: (data: Types.MeasurementImportSettingsDto | undefined) => Types.MeasurementImportSettingsDto, deviceModel?: Types.DeviceModel | undefined) {
  queryClient.setQueryData(getQueryKey(deviceModel),
    updater
  );
}

/**
 * Gets Measurement import settings for current tenant.
 * @param deviceModel (optional) 
 */
export function setGetDataByQueryId(queryClient: QueryClient, queryKey: QueryKey, updater: (data: Types.MeasurementImportSettingsDto | undefined) => Types.MeasurementImportSettingsDto) {
  queryClient.setQueryData(queryKey, updater);
}
    
export function patchUrl(deviceModel?: Types.DeviceModel | undefined): string {
  let url_ = getBaseUrl() + "/api/measurements/import-settings?";
if (deviceModel === null)
    throw new Error("The parameter 'deviceModel' cannot be null.");
else if (deviceModel !== undefined)
    url_ += "deviceModel=" + encodeURIComponent("" + deviceModel) + "&";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function patchMutationKey(deviceModel?: Types.DeviceModel | undefined): MutationKey {
  return trimArrayEnd([
      'MeasurementImportSettingsClient',
      'patch',
      deviceModel as any,
    ]);
}

/**
 * Patches Measurement import settings for current tenant.
 * @param deviceModel (optional) 
 */
export function usePatchMutation<TContext>(deviceModel?: Types.DeviceModel | undefined, options?: Omit<UseMutationOptions<void, unknown, Types.MeasurementImportSettingsPatchDto, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<void, unknown, Types.MeasurementImportSettingsPatchDto, TContext> {
  const key = patchMutationKey(deviceModel);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: (dto: Types.MeasurementImportSettingsPatchDto) => Client.patch(dto, deviceModel),
    mutationKey: key,
  });
}
  
type Patch__MutationParameters = PatchMeasurementImportSettingsQueryParameters & {
  dto: Types.MeasurementImportSettingsPatchDto;
}

/**
 * Patches Measurement import settings for current tenant.
 * @param deviceModel (optional) 
 */
export function usePatchMutationWithParameters<TContext>(options?: Omit<UseMutationOptions<void, unknown, Patch__MutationParameters, TContext>, 'mutationKey' | 'mutationFn'> & { parameters?: PatchMeasurementImportSettingsQueryParameters}): UseMutationResult<void, unknown, Patch__MutationParameters, TContext> {
  const key = patchMutationKey(options?.parameters?.deviceModel!);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
return useMutation({
  ...options, 
  mutationFn: (data: Patch__MutationParameters) => Client.patch(data.dto, data.deviceModel ?? options?.parameters?.deviceModel!),
  mutationKey: key,
});
}